import { DataHubView } from '@app/src/pages/ResourceCollection/Collections/DataHubScene'
import { ViewTypeName } from '@app/src/pages/ResourceCollection/Collections/ManageRequests/ManageRequestsScene'
import { ProviderTabs } from '@app/src/pages/ResourceCollection/Collections/Providers/ProvidersScene'
import { RiskScreeningViews } from '@app/src/pages/ResourceCollection/Collections/RiskScreening/RiskScreeningScene'
import { TopicalRiskViews } from '@app/src/pages/TopicalRisk/topicalRiskViews'
import { Flows } from '@app/src/wf-constants'
import paths from '@app/src/wf-constants/paths'
import { generatePath } from 'react-router-dom'
import { AllAssessmentsViews } from '../pages/Assessments/AllAssessments/AllAssessmentsScene'
import { AssessmentViews } from '../pages/Assessments/Assessment/assessmentViews'

export const providers = generatePath(paths.providers, { view: ProviderTabs.All })
export const contacts = generatePath(paths.contacts)
export const responseItems = generatePath(paths.dataHubCollection, {
  flow: Flows.Interaction,
  view: DataHubView.DataInsights,
})
export const transparencySubscriptions = generatePath(paths.subscriptions)
export const evaluations = generatePath(paths.evaluations)
export const dashboard = generatePath(paths.dashboard)
export const notifications = generatePath(paths.notifications)
export const co2eCalculator = generatePath(paths.co2eCalculator)
export const products = generatePath(paths.productsCollection)
export const productMappingCompanies = generatePath(paths.productMappingCompanies)
export const productMappingContacts = generatePath(paths.productMappingContacts)
export const valueChains = generatePath(paths.valueChainCollection)
export const mappingRequests = generatePath(paths.mappingRequestCollection)
export const sentMappingRequests = generatePath(paths.sentMappingRequestCollection)
export const receivedMappingResponses = generatePath(paths.receivedMappingResponseCollection)
export const requests = generatePath(paths.manageRequest, { view: ViewTypeName.Requests })
export const screenedResponses = generatePath(paths.manageRequest, { view: ViewTypeName.ScreenedRequests })
export const responses = generatePath(paths.manageRequest, { view: ViewTypeName.Responses })
export const manageRequestOverview = generatePath(paths.manageRequest, { view: ViewTypeName.Overview })
export const providerRisk = generatePath(paths.providerRisk)
export const riskScreeningHq = generatePath(paths.riskScreening, { view: RiskScreeningViews.Headquarter })
export const riskScreeningAllLocations = generatePath(paths.riskScreening, {
  view: RiskScreeningViews.Headquarter,
})
export const topicalRisk = generatePath(paths.topicalRisk)
// The tab that hosts the table. Separate from the link above, which the menus use and which the legacy
// scene also answers: it knows nothing about these views.
export const topicalRiskDetails = generatePath(paths.topicalRisk, { view: TopicalRiskViews.Details })
export const assessments = generatePath(paths.assessments, { view: AssessmentViews.Overview })
export const allAssessments = generatePath(paths.allAssessments, { view: AllAssessmentsViews.Overview })
export const insightsReport = generatePath(paths.insightsReport)
export const supplyChainDueDiligenceStatement = generatePath(paths.supplyChainDueDiligenceStatement)
export const expectations = generatePath(paths.sourcingExpectationsList)
export const findings = generatePath(paths.findings)
export const recommendedJourney = generatePath(paths.recommendedJourney)
export const transparencySustainabilityProfile = generatePath(paths.transparencySustainabilityProfile)
export const platformReleases = generatePath(paths.platformReleases)

const navigationLinks = {
  providers,
  contacts,
  responseItems,
  transparencySubscriptions,
  evaluations,
  dashboard,
  notifications,
  co2eCalculator,
  products,
  valueChains,
  mappingRequests,
  sentMappingRequests,
  receivedMappingResponses,
  productMappingCompanies,
  productMappingContacts,
  requests,
  screenedResponses,
  responses,
  manageRequestOverview,
  providerRisk,
  riskScreeningHq,
  assessments,
  allAssessments,
  insightsReport,
  supplyChainDueDiligenceStatement,
  topicalRisk,
  topicalRiskDetails,
  expectations,
  findings,
  recommendedJourney,
  transparencySustainabilityProfile,
  platformReleases,
}

export default navigationLinks
